export const permissionsFull = 'admin_jornal';
export const permissionsExtend = 'mod_jornal';
